var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('h1',{staticClass:"h1"},[_vm._v(" Demo complete! ")])]),_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('p',[_vm._v(_vm._s(_vm.params.completionText))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }